var _path, _path2, _path3, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3445 9.29847V6.59747C31.3445 3.83605 29.1059 1.59747 26.3445 1.59747H7.02814C4.26671 1.59747 2.02814 3.83605 2.02814 6.59747V27.4015C2.02814 30.1629 4.26672 32.4015 7.02814 32.4015H26.3445C29.1059 32.4015 31.3445 30.1629 31.3445 27.4015V24.7005",
    stroke: "#026597",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4481 11.4412C19.4481 13.3431 17.9294 14.8628 16.0831 14.8628C14.2368 14.8628 12.7181 13.3431 12.7181 11.4412C12.7181 9.5392 14.2368 8.01947 16.0831 8.01947C17.9294 8.01947 19.4481 9.5392 19.4481 11.4412Z",
    stroke: "#026597",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8278 20.0248C23.3195 19.0019 22.5808 18.1081 21.6685 17.4122C20.7562 16.7163 19.6948 16.2369 18.5658 16.0108C17.4368 15.7847 16.2705 15.818 15.1565 16.1081C14.0426 16.3983 13.0108 16.9375 12.1406 17.6843C11.2704 18.4311 10.585 19.3655 10.1371 20.4157C9.68927 21.4658 9.49091 22.6037 9.55732 23.7417C9.62374 24.8796 9.95316 25.9873 10.5202 26.9795",
    stroke: "#026597",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.0917,
    y1: 19.4879,
    x2: 39.4249,
    y2: 19.4879,
    stroke: "#026597",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 5.07312,
    y2: -0.75,
    transform: "matrix(0.73034 -0.683084 0.776829 0.629711 35.7198 23.7033)",
    stroke: "#026597",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.0917,
    y1: 16.0684,
    x2: 39.4249,
    y2: 16.0684,
    stroke: "#026597",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 5.07312,
    y2: -0.75,
    transform: "matrix(0.73034 -0.683084 0.776829 0.629711 29.3599 16.2303)",
    stroke: "#026597",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchUser);
export default __webpack_public_path__ + "static/media/SwitchUser.d59bbecb920f0b4c50768cdc85972872.svg";
export { ForwardRef as ReactComponent };